module.exports = __webpack_public_path__ + "img/16581300_S.4aae45f4.png";